<template>
  <filter-table
    primary-key="id"
    :fields="fields"
    :items="items"
    :slots="templates"
    :show-empty="false"
    :filter-function="filterFunction"
    :sort-compare="sortCompare"
    :sticky-header="true"
    @row-clicked="rowClicked"
  >
    <template slot="number" slot-scope="row">
      <div class="d-flex">
        <span class="btn-link number-link">{{row.value}}</span>
      <badge pill variant="danger"
        v-b-tooltip.hover
        title="Needed files"
        xOffset="-13"
        yOffset="9"
        :text="row.row.item.needed_files.length"
        v-if="row.row.item.needed_files.length > 0">
       </badge>
      </div>
    </template>
    <template slot="percentage_to_funded" slot-scope="row">
      <b-progress animated>
        <b-progress-bar :value="row.value*100">
        </b-progress-bar>
      </b-progress>
    </template>
    <template slot="draw_percentage" slot-scope="row">
      <b-progress
        v-if="row.value"
        v-b-tooltip.hover
        animated
        :title="row.value[1]"
      >
        <b-progress-bar :value="row.value[0]*100">
        </b-progress-bar>
      </b-progress>
    </template>
    <template slot="amount" slot-scope="row">
      {{ row.value | currency }}
    </template>
    <template slot="transaction_type" slot-scope="row">
      {{ row.value | unCamelCase }}
    </template>
    <template slot="loan_category" slot-scope="row">
      {{ row.value | category }}
    </template>
    <template slot="holdback" slot-scope="row">
      {{ row.value | currency }}
    </template>
    <template slot="holdback_balance" slot-scope="row">
      {{ row.value | currency }}
    </template>
    <template slot="servicing_current_pay_amount" slot-scope="row">
      {{ row.value | currency }}
    </template>
    <template slot="draw_date" slot-scope="row">
      {{ row.value | unCamelCase }}
    </template>
    <template slot="actions" slot-scope="row">
      <b-button
        size="sm"
        class="btn-anchor"
        @click.stop="$emit('action-clicked', row.row.item)"
        aria-label="Action"
        :disabled="!allowed"
      >
        <font-awesome-icon icon="plus-square" />
      </b-button>
    </template>
    <template slot="caption">
      <slot name="caption"></slot>
    </template>
    <template slot="header">
      <slot name="header"></slot>
    </template>
  </filter-table>
</template>


<script>
import helper from '@/libs/helper';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faExclamationTriangle, faPlusSquare } from '@fortawesome/free-solid-svg-icons';

import Badge from '@/components/utils/Badge';
import DocumentsLegend from '@/components/utils/DocumentsLegend';
import FilterTable from '@/components/utils/FilterTable';
import Spinner from '@/components/utils/Spinner';
import { LOANS_WRITE } from '@/libs/permissions_list';
import InfiniteLoading from 'vue-infinite-loading';

import CategoryPresentation from '../resources/CategoryPresentation.json';


library.add([faExclamationTriangle, faPlusSquare]);


export default {
  components: {
    Badge,
    DocumentsLegend,
    FilterTable,
    InfiniteLoading,
    Spinner,
  },
  props: {
    loans: {
      type: Array,
      required: true,
    },
    fields: Array,
    filterFunction: Function,
    sortCompare: Function,
    captions: Array,
    formatFunction: Function,
  },
  data: () => ({
    templates: [
      { key: 'number' },
      { key: 'percentage_to_funded' },
      { key: 'draw_percentage' },
      { key: 'amount' },
      { key: 'servicing_current_pay_amount' },
      { key: 'transaction_type' },
      { key: 'loan_category' },
      { key: 'holdback' },
      { key: 'holdback_balance' },
      { key: 'draw_date' },
      { key: 'actions' },
    ],
  }),
  computed: {
    items() {
      return this.formatFunction ?
        this.formatFunction(this.format(this.loans)) :
        this.format(this.loans);
    },
    allowed() {
      return this.$permissions.checkPermissions([LOANS_WRITE]);
    },
  },
  methods: {
    format(loans) {
      const resolveDate = (keys, target) => {
        /* eslint no-param-reassign: "error" */
        keys.forEach((key) => {
          const tmp = target[key];
          if (tmp) {
            target[key] = helper.formatDate(tmp);
          }
        });
      };

      return loans.map((loan) => {
        const formatted = helper.copy(loan);
        const baseDateKeys = [
          'date_entered',
          'estimated_close_date',
          'maturity_date',
          'draw_date',
        ];
        const checklistDateKeys = ['funded', 'payoff_date'];
        resolveDate(baseDateKeys, formatted);
        resolveDate(checklistDateKeys, formatted.checklist);

        return formatted;
      });
    },
    rowClicked(item) {
      this.$router.push({ name: 'DealDetail', params: { loan_id: item.id } });
    },
  },
  filters: {
    unCamelCase(value) {
      if (!value) return '';
      const result = value.replace(/([A-Z])/g, ' $1').replace(/^./, str => (str.toUpperCase()));
      return result;
    },
    category(value) {
      const category = CategoryPresentation[value];
      if (category) {
        return category;
      }

      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
};
</script>
<style scoped>
.number-link {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/my_deals/deals/LoansTable.vue